var map = {
	"./1280px-Scientific_American_logo.svg-min_lxwih7.png": 4642,
	"./20170618023142_University_College_London_logo-min_ugwkwt.png": 4488,
	"./Manchester_title_hi6i38.png": 6886,
	"./asus.png": 3794
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2230;